const firstOr = <T>(valueIfNone: T) => (list: T[]): T => {
  return list[0] ?? valueIfNone
}

export { firstOr }
